import type { SystemId } from '../../contracts/api'

export type { SystemId }

const COLORS: Record<SystemId, string> = {
  bazi: '#C9924D',
  ziwei: '#A34D66',
  tzolkin: '#3FC9B4',
  iching: '#E9E4D6',
}

/**
 * Значок системы рядом с выводом — чтобы человек в один взгляд видел,
 * какие карты за этим стоят. Штрихи не тоньше 1.4: тоньше пропадает на телефоне.
 */
export function SystemIcon({ system, size = 18 }: { system: SystemId; size?: number }) {
  const color = COLORS[system]
  return (
    <svg className="base-ico" viewBox="0 0 18 18" width={size} height={size} aria-hidden="true">
      {system === 'bazi' && <rect x="6.5" y="2" width="5" height="14" rx="1.5" fill="none" stroke={color} strokeWidth="1.5" />}
      {system === 'ziwei' && (
        <path d="M9 2.5l1.8 4.7L15.5 9l-4.7 1.8L9 15.5 7.2 10.8 2.5 9l4.7-1.8z" fill="none" stroke={color} strokeWidth="1.4" />
      )}
      {system === 'tzolkin' && (
        <>
          <path d="M9 3l5 6-5 6-5-6z" fill="none" stroke={color} strokeWidth="1.5" />
          <circle cx="9" cy="9" r="1.6" fill={color} />
        </>
      )}
      {system === 'iching' && (
        <g fill={color}>
          <rect x="3" y="4" width="12" height="1.6" rx="0.8" />
          <rect x="3" y="8.2" width="5" height="1.6" rx="0.8" />
          <rect x="10" y="8.2" width="5" height="1.6" rx="0.8" />
          <rect x="3" y="12.4" width="12" height="1.6" rx="0.8" />
        </g>
      )}
    </svg>
  )
}
